import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    Output,
} from "@angular/core";

import { Settings } from "@hermes/app-core";

/**
 * @description
 *
 * A directive to update image src with defaultImage when error occurs.
 *
 * @usageNotes
 *
 * Apply default image (h Hermès for product by default).
 *
 * ```
 * <img hImageErrorDefault ...>
 * ```
 *
 * Apply specific image url.
 *
 * ```
 * <img [hImageErrorDefault]="defaultUrl" ...>
 * ```
 */
@Directive({ selector: "img[hImageErrorDefault]", standalone: true })
export class ImageErrorDefaultDirective {
    @Input("hImageErrorDefault") public defaultImage?: string;
    @Output() public defaultErrored = new EventEmitter<void>();

    private isFirstError = true;
    private fallbackImage = `${this.settings.assetsUrlProduct}thumbnail_default`;

    constructor(private settings: Settings, private element: ElementRef) {}

    @HostListener("error", ["$event"])
    public updateSrcOnError(): void {
        if (!this.isFirstError || this.defaultImage === undefined) {
            return;
        }

        this.defaultErrored.emit();
        this.isFirstError = false;

        this.element.nativeElement.setAttribute(
            "src",
            this.defaultImage || this.fallbackImage,
        );
    }
}
